import type { Theme } from '@mui/material';
import type { Components } from '@mui/material/styles';

export default function MUITypography(theme: Theme): Components['MuiTypography'] {
  return {
    defaultProps: {
      variant: 'body1',
      color: 'inherit',
      variantMapping: {
        h1: 'div',
        h2: 'div',
        h3: 'div',
        h4: 'div',
        h4Alt: 'div',
        h5: 'div',
        h6: 'div',
        h6Alt: 'div',
        subtitle1: 'div',
        subtitle2: 'div',
        body1: 'span',
        body2: 'span',
        caption: 'span',
        captionSmall: 'span',
        captionXSmall: 'span',
        overline: 'span',
        inherit: 'span',
      },
    },
    styleOverrides: {
      gutterBottom: {
        marginBottom: theme.spacing(1),
      },
    },
  };
}
